import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Icon } from "rhombus-react";
import { push } from "connected-react-router";

export default function ContentFeedViewDetails({
	contentFeedName,
	format,
	url,
	itemKey,
	eligibleItems,
	totalItems,
	lastSync,
	mapping,
	contentFeedId,
	libraryId,
}) {
	const dispatch = useDispatch();

	const handleViewDetails = () => {
		dispatch(push({
			pathname: `/library/${libraryId}/content-feeds/modal/view-details/${contentFeedId}/`,
			state: {
				contentFeedName,
				format,
				url,
				itemKey,
				eligibleItems,
				totalItems,
				lastSync,
				mapping,
			},
		}));
	};

	return (
		<Icon
			name="fas fa-info-circle is-info"
			className="bounce-circle"
			data-tip="View Details"
			onClick={handleViewDetails}
		/>
	);
}

ContentFeedViewDetails.displayName = "ContentFeedViewDetails";

ContentFeedViewDetails.propTypes = {
	contentFeedName: PropTypes.string.isRequired,
	format: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
	itemKey: PropTypes.string,
	eligibleItems: PropTypes.number,
	totalItems: PropTypes.number,
	lastSync: PropTypes.string,
	mapping: PropTypes.object,
	contentFeedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	libraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

